import {
  Card,
  Dialog,
  H2,
  H3,
  Icon,
  ListRow,
  PancakeStack,
  ScrollArea,
  Separator,
  Sheet,
  Text,
} from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { AutoApplySetting } from './sheets/AutoApplySetting';
import { CashFund } from './sheets/CashFund';
import { ForfeitureFund } from './sheets/ForfeitureFund';
import { Notices } from './sheets/Notices';
import { QDIADisclosures } from './sheets/QDIADisclosures';
import { SummaryAnnualReport } from './sheets/SummaryAnnualReport';
import { SuspenseFund } from './sheets/SuspenseFund';

import { baseUnstyledButtonStyles } from '../../layout/sidebar/SidebarButton';

const TopicListRow: React.FC<{ title: string; sheetContent: React.ReactNode; alternateSheetTitle?: string }> = ({
  title,
  sheetContent,
  alternateSheetTitle,
}) => (
  <Sheet overlay="weak">
    <Sheet.Trigger css={{ ...baseUnstyledButtonStyles, _hover: { backgroundColor: 'transparent' } }}>
      <ListRow css={{ p: 'space.0', pt: 'space.200' }}>
        <ListRow.LeadingContent>
          <Text>{title}</Text>
        </ListRow.LeadingContent>
        <ListRow.TrailingAsset>
          <Icon name="CaretRight" size="small" />
        </ListRow.TrailingAsset>
      </ListRow>
    </Sheet.Trigger>
    <Sheet.Content aria-describedby={undefined}>
      <PancakeStack css={{ height: '100dvh' }}>
        <PancakeStack.Header css={{ p: 'space.400', pb: 'space.300', maxWidth: '350px' }}>
          <Dialog.Title>{alternateSheetTitle || title}</Dialog.Title>
        </PancakeStack.Header>
        <PancakeStack.Main css={{ px: 'space.400', overflow: 'hidden' }}>
          <ScrollArea css={{ height: '100%', pb: 'space.400' }}>{sheetContent}</ScrollArea>
        </PancakeStack.Main>
      </PancakeStack>
    </Sheet.Content>
  </Sheet>
);

export const PopularTopicsCard: React.FC = () => {
  return (
    <Card css={{ p: 'space.300' }}>
      <Card.Header>
        <H2 variant="title200">Popular topics</H2>
      </Card.Header>
      <Separator css={{ my: 'space.300' }} />
      <Card.Content>
        <H3 variant="title100">Unallocated funds</H3>
        <TopicListRow title="Forfeiture fund" sheetContent={<ForfeitureFund />} />
        <TopicListRow title="Suspense fund" sheetContent={<SuspenseFund />} />
        <TopicListRow title="Cash fund" sheetContent={<CashFund />} />
        <TopicListRow
          title="Auto apply setting"
          alternateSheetTitle="Unallocated funds"
          sheetContent={<AutoApplySetting />}
        />

        <Separator css={{ my: 'space.300' }} />

        <H3 variant="title100">Documents</H3>
        <TopicListRow title="QDIA and fee disclosures" sheetContent={<QDIADisclosures />} />
        <TopicListRow title="Notices (Safe Harbor, Auto-enrollment)" sheetContent={<Notices />} />
        <TopicListRow title="Summary annual report (SAR)" sheetContent={<SummaryAnnualReport />} />
      </Card.Content>
      <Separator css={{ my: 'space.300' }} />
      <Card.Footer>
        <SambaAutoLink to={urlBuilder.getResources()} target="_blank" rel="noopener noreferrer">
          View all resources
        </SambaAutoLink>
      </Card.Footer>
    </Card>
  );
};
